import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/company-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/company-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/company-profiles/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/company-profiles/${data.company_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/company-profiles/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const storelogo = file => {
  return httpClient
    .post('/api/company-profiles/logos', file)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getlogo = id => {
  return httpClient
    .get(`/api/company-profiles/${id}/logos`, {
      responseType: 'arraybuffer'
    })
    .then(response =>
      Promise.resolve(
        `data:image/jpg;base64,${new Buffer(response.data, 'binary').toString(
          'base64'
        )}`
      )
    )
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, find, update, destroy, storelogo, getlogo }
